/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import * as Config from "config/constant";
import { getIsApp } from "config/constant";
import {
	NETWORK_ERROR,
	PERMISSION_DENIED,
	SESSION_EXPIRES
} from "utils/httpStatusCode";

const DOMAIN_KIDO = {
	"localhost:3000": "https://sb-shop.kido.vn",
	"sb-shop.kido.vn": "https://sb-shop.kido.vn",
	"kh.kido.vn": "https://kh.kido.vn"
};

export const DOMAIN = DOMAIN_KIDO[window?.location?.host || "localhost:3000"];

const AppAPIInstance = axios.create({
	baseURL: DOMAIN,
	headers: {
		"Content-Type": "application/json"
	}
});

let isPostMessageLogout = false;

AppAPIInstance.interceptors.response.use(
	async response => {
		const { data, config } = response;
		const originalRequest = config;
		let sid = "";
		const isApp = getIsApp();
		if (data.code === PERMISSION_DENIED) {
			sid = await refreshAccessCookie(); // TODO:
			localStorage.setItem("SID", sid);
			originalRequest.headers.Authorization = sid;
			return axios(originalRequest);
		}

		if (data.code === SESSION_EXPIRES) {
			if (typeof window !== "undefined" && !isPostMessageLogout) {
				localStorage.clear();
				isPostMessageLogout = true;
				console.log("CHAY");
				window?.ReactNativeWebView?.postMessage("LOGOUT");
			}
			if (!isApp) {
				localStorage.clear();
				window.location.replace("/");
			}
			return;
		}
		return Promise.resolve(response?.data);
	},
	error => {
		if (error.message === NETWORK_ERROR) {
			window.location.href = `${window.location.origin}/network_error`;
		}
		return Promise.reject(error);
	}
);

const refreshAccessCookie = () => {
	return new Promise((resolve, reject) => {
		return axios
			.get(`${DOMAIN}/${Config.API_REFRESH_COOKIE_PATH}`)
			.then(res => {
				if (res.data.code === 0) {
					resolve(res.data.data.sid);
				} else {
					resolve(localStorage.getItem("SID"));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
};

const getHeaders = props => {
	const currentToken = localStorage.getItem("token");
	const { token = currentToken, contentType } = props;
	const headers = {};
	if (token) {
		headers["Authorization"] = token;
	}
	if (contentType) {
		headers["Content-Type"] = contentType;
	}
	return headers;
};

const getParams = props => {
	const currentInfoDevice = localStorage.getItem("infoDevice");
	const parseInfo = JSON.parse(currentInfoDevice);
	const { infoDevice = parseInfo } = props;
	return {
		...(infoDevice || {})
	};
};

export default {
	get(pathname, token, infoDevice, options = {}) {
		return AppAPIInstance.get(pathname, {
			headers: getHeaders({ token }),
			params: getParams({ infoDevice }),
			...options
		});
	},
	post(pathname, data, token, infoDevice, options = {}) {
		return AppAPIInstance.post(pathname, data, {
			headers: getHeaders({ token }),
			params: getParams({ infoDevice }),
			...options
		});
	},
	put(pathname, data, token, infoDevice, options = {}) {
		return AppAPIInstance.put(pathname, data, {
			headers: getHeaders({ token }),
			params: getParams({ infoDevice }),
			...options
		});
	},
	delete(pathname, data, token, infoDevice, options = {}) {
		return AppAPIInstance.delete(pathname, data, {
			headers: getHeaders({ token }),
			params: getParams({ infoDevice }),
			...options
		});
	}
};
